import { motion } from "framer-motion";

const PolicyPage = () => {
  return (
    <div data-testid="policy-page" className="min-h-screen pt-20">
      {/* Header */}
      <section className="py-16 md:py-20 border-b border-white/5">
        <div className="max-w-[1600px] mx-auto px-6 md:px-12 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <p className="mono-text text-primary mb-6">Our Commitment</p>
            <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight mb-6">
              Policy
            </h1>
          </motion.div>
        </div>
      </section>

      {/* Policy Content */}
      <section className="py-16 md:py-24">
        <div className="max-w-[900px] mx-auto px-6 md:px-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="space-y-8"
          >
            <p className="text-lg text-foreground leading-relaxed">
              Thank you for shopping with Laguerre.
            </p>
            
            <p className="text-muted-foreground leading-relaxed">
              We are committed to delivering exceptional service and craftsmanship. Please review the information below to ensure a seamless experience with your custom garment(s):
            </p>

            <div className="space-y-6">
              <div className="border-l-2 border-primary pl-6">
                <p className="text-foreground leading-relaxed">
                  <span className="text-primary font-medium">1.</span> To meet our turnaround timeline, production will begin immediately. Once your order is finalized, all design selections—including fabric, lining, monogram, and styling details—are final and cannot be modified.
                </p>
              </div>

              <div className="border-l-2 border-primary pl-6">
                <p className="text-foreground leading-relaxed">
                  <span className="text-primary font-medium">2.</span> The consultant who assisted you will remain your primary point of contact at Laguerre. Please reach out to them directly via email with any questions or to reschedule an appointment.
                </p>
              </div>

              <div className="border-l-2 border-primary pl-6">
                <p className="text-foreground leading-relaxed">
                  <span className="text-primary font-medium">3.</span> As each garment is custom-made specifically for you, we do not accept returns, exchanges, or offer refunds. However, we are pleased to provide complimentary alterations within 60 days of your garment's ready date to ensure the best possible fit.
                </p>
              </div>

              <div className="border-l-2 border-primary pl-6">
                <p className="text-foreground leading-relaxed">
                  <span className="text-primary font-medium">4.</span> Please arrange to pick up your garment(s) promptly once notified. Laguerre cannot be held responsible for items left unclaimed for more than 60 days.
                </p>
              </div>
            </div>

            <div className="pt-8 border-t border-white/10">
              <p className="text-muted-foreground leading-relaxed italic">
                We appreciate your trust in Laguerre and look forward to delivering your custom piece.
              </p>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default PolicyPage;
